import { connect } from 'react-redux';
import LocationWidget from 'nucleus-widgets/lib/Location/LocationWidget';

/**
* Data wrapper for the event location widget.
*/

export default connect((state) => {
  return {
    location: state.event.location,
    address: state.event.address
  };
})(LocationWidget);
